export let ViewState = /*#__PURE__*/function (ViewState) {
  ViewState["LOADING"] = "loading";
  ViewState["SUCCESS"] = "success";
  ViewState["ERROR"] = "error";
  return ViewState;
}({});
//# sourceMappingURL=types.js.map